<template>
  <!-- <div @click="opendetailrightsidebar"><i class="pi pi-bars"></i></div> -->
  <div :style="{ width: sidebarwidth }" class="rightdetailssidebar" v-if="trigger">
    <!-- {{ model }}s{{ selectedItem }} -->
    <!-- {{isFetchData.Id}} -->
    <!-- {{ model }} -->
    <div class="firstcontent">
      <div class="sidebar-header">
        <h6>{{ t("assetManagement.MassConverstion.tableheading") }}</h6>
        <i class="pi pi-arrow-right" @click="closedetailsrightsidebar"> </i>
      </div>
      <!-- {{ isFetchData }} -->
      <!-- {{ isForm }} -->
      <div class="sidebar-content">
        <b-row class="px-3">
          <b-col sm="12" md="12" lg="12" xl="12">
            <b-row>
              <b-col lg="4" md="4" sm="6" cols="6" class="form-field-column">
                <p class="light-txt">Item Name :</p>
              </b-col>
              <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-start">
                <p class="fn14 me-3">{{ isFetchData.Name }}</p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="px-3">
          <b-col sm="12" md="12" lg="12" xl="12">
            <b-row>
              <b-col lg="4" md="4" sm="6" cols="6" class="form-field-column">
                <p class="light-txt">Brand/Model/Size :</p>
              </b-col>
              <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-start">
                <p class="fn14 me-3">
                  {{
                    [
                      isFetchData.BrandName,
                      isFetchData.ModelNumberName,
                      isFetchData.SizeName,
                    ]
                      .filter(Boolean)
                      .join(" / ")
                  }}
                </p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mb-1 px-3">
          <b-col sm="12" md="12" lg="12" xl="12">
            <b-row>
              <b-col lg="4" md="4" sm="6" cols="6" class="form-field-column">
                <p class="light-txt">Asset Type :</p>
              </b-col>
              <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-start">
                <p class="fn14 me-3">{{ isFetchData.ItemCategoryName }}</p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="px-3">
          <b-col sm="12" md="12" lg="12" xl="12">
            <b-row>
              <b-col lg="4" md="4" sm="6" cols="6" class="form-field-column">
                <p class="light-txt">Asset Group :</p>
              </b-col>
              <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-start">
                <p class="fn14 me-3">{{ isFetchData.ItemGroupName }}</p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row class="px-3">
          <b-col sm="12" md="12" lg="12" xl="12">
            <b-row>
              <b-col lg="4" md="4" sm="6" cols="6" class="form-field-column">
                <p class="light-txt">Supplier Name :</p>
              </b-col>
              <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-start">
                <p class="fn14 me-3">{{ isFetchData.SupplierName }}</p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row class="px-3">
          <b-col sm="12" md="12" lg="12" xl="12">
            <b-row>
              <b-col lg="4" md="4" sm="6" cols="6" class="form-field-column">
                <p class="light-txt">GRN Number :</p>
              </b-col>
              <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-start">
                <p class="fn14 me-3">{{ isFetchData.DocNo }}</p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row class="px-3">
          <b-col sm="12" md="12" lg="12" xl="12">
            <b-row>
              <b-col lg="4" md="4" sm="6" cols="6" class="form-field-column">
                <p class="light-txt">Purchase Date :</p>
              </b-col>
              <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-start">
                <p class="fn14 me-3">{{ isFetchData.InvoiceDate }}</p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="px-3">
          <b-col sm="12" md="12" lg="12" xl="12">
            <b-row>
              <b-col lg="4" md="4" sm="6" cols="6" class="form-field-column">
                <p class="light-txt">Item BarCode :</p>
              </b-col>
              <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-start">
                <p class="fn14 me-3">{{ isFetchData.StockInDetailBarcode }}</p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-form>
          <b-row class="mt-1">
            <b-col sm="8">
              <div class="field">
                <!-- {{ selectedItem!.Quantity }}a -->

                <TextField v-model="isForm.ModelNo" type="text" :label="t('assetManagement.MassConverstion.modelno')"
                  clearable :disabled="commonStore.option.listAssetByItem.length >= Number(selectedItem!.Quantity)"
                  :id="t('assetManagement.MassConverstion.modelno')"
                  :name="t('assetManagement.MassConverstion.modelno')" :rules="{ required: false }"
                  :required-icon="false" />
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col sm="8">
              <!-- {{ commonStore.option.listAssetByItem.length }}
                            {{ Number(selectedItem!.Qty) }} -->
              <div class="field">
                <TextField v-model="isForm.SerialNumber" type="text"
                  :label="t('assetManagement.MassConverstion.serialNumber')" clearable
                  :disabled="commonStore.option.listAssetByItem.length >= Number(selectedItem!.Quantity)"
                  :id="t('assetManagement.MassConverstion.serialNumber')"
                  :name="t('assetManagement.MassConverstion.serialNumber')" :rules="{ required: false }"
                  :required-icon="false" @keyup="handleSerialNoChange()" />
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col lg="6" md="6" sm="12" cols="12">
              <!-- v-if="isForm.SerialNumber == '' && qtyLoop != ''"  -->
              <div class="field">
                <TextField v-if="isForm.SerialNumber == ''" v-model="isvarForm.qtyLoop" type="text" label="Qty"
                  clearable id="Qty" name="Qty" :rules="{ required: false, numeric: true }" :required-icon="false"
                  @keyup="handleQtyChange()" />
              </div>
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col lg="12" md="12" sm="12" cols="12">
              <div class="field">
                <label path="Branch my-2">{{
                  t("assetManagement.MassConverstion.agreementType")
                }}</label>
                <div>
                  <div class="d-flex flex-wrap gap-3">
                    <div v-for="option in checkboxOptions" :key="option.value" class="d-flex align-items-center">
                      <Checkbox :inputId="'checkbox' + option.value" :name="'checkbox' + option.value"
                        :value="option.value" v-model="agreementType" :disabled="isDisabled(option.value)"
                        @change="handleChange(option.value)" />
                      <label :for="'checkbox' + option.value" class="radio-label">{{ option.label }}</label>
                    </div>
                  </div>
                  <div v-if="errorMessage" class="error-message red-txt mt-2">
                    {{ errorMessage }}
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6" md="6" sm="12">
              <div class="field">
                <CustomDropDownfield :label="t('assetManagement.MassConverstion.location')" v-model="isForm.LocationID"
                  :items="commonStore.option.locationList" :rules="{ required: false }" :required-icon="false"
                  :id="t('assetManagement.MassConverstion.location')"
                  :name="t('assetManagement.MassConverstion.location')" />
              </div>
            </b-col>
            <b-col lg="6" md="6" sm="12">
              <div class="field">
                <CustomDropDownfield label="Asset Lifecycle Stage" v-model="isForm.AssetLifecycleStage"
                  :items="commonStore.option.AssetLifecycleStage" :rules="{ required: false }" :required-icon="false"
                  :id="'Asset Lifecycle Stage'" :name="'Asset Lifecycle Stage'" />
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col lg="8" md="8" sm="8" cols="8">
              <div class="field">
                <label>{{
                  t("assetManagement.assetassign.trackingMechanism")
                }}</label>
                <div class="field-radiobutton mt-2" style="display: flex; gap: 10px">
                  <RadioButton v-model="isForm.TrackingMechanism" inputId="rfid" :value="1"
                    :class="{ 'active-radio': isForm.TrackingMechanism === 1 }" />
                  <label for="rfid">{{
                    t("assetManagement.assetassign.rfid")
                  }}</label>
                  <RadioButton v-model="isForm.TrackingMechanism" inputId="gps" :value="2"
                    :class="{ 'active-radio': isForm.TrackingMechanism === 2 }" />
                  <label for="gps">{{
                    t("assetManagement.assetassign.gps")
                  }}</label>
                  <RadioButton v-model="isForm.TrackingMechanism" inputId="bluetooth" :value="3"
                    :class="{ 'active-radio': isForm.TrackingMechanism === 3 }" />
                  <label for="bluetooth">{{
                    t("assetManagement.assetassign.bluetooth")
                  }}</label>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <!-- <b-col lg="6" md="6" sm="12" cols="12">
                            <div class="field">
                                <CustomDatepicker placeholder="" label="Purchase Date" name="Purchase Date"
                                    id="Purchase Date" :required-icon="false" :rules="{ required: false }"
                                    v-model="isForm.PurchaseDate" />
                            </div>
                        </b-col> -->
            <b-col lg="6" md="6" sm="12" cols="12" v-if="isForm.TrackingMechanism != 0">
              <div class="field">
                <TextField v-model="isForm.RfidTag" type="text" :label="getTrackingLabel()" clearable
                  :id="getTrackingLabel()" :name="getTrackingLabel()" :rules="{ required: false }"
                  :required-icon="false" />
              </div>
            </b-col>
          </b-row>

          <Footer @cancel="closedetailsrightsidebar" :cancelhide="true" label="Add to List" @save="isSubmitvalidate()"
            CancelLabel="Cancel" type="submit" />
        </b-form>

        <div>
          <SkeletonTableLoader :columns="headers" :loading="loading" />
          <div v-if="!loading">

            <!-- {{ selectedProduct }} -->
            <!-- {{ commonStore.option.listAssetByItem }} -->
            <NormalTableview v-model:value="commonStore.option.listAssetByItem" :paginator="false"
              class="p-datatable-gridlines" :rows="10" dataKey="id" :rowHover="true" filterDisplay="menu"
              :loading="loading" responsiveLayout="scroll" :columns="headers" v-model:selection="selectedProduct"
              :selectionMode="true" :CheckDisabled="showdetails == true ? 'disableclass' : 'False'">
              <template v-slot:Add> </template>

              <template v-slot:AgreementName="{ data }">
                <span>
                  {{ data.AgreementName }}

                  <!-- <OrangeStatus name="InActive" v-if="data.IsActive == '0'" />
                                    <GreenStatus name="Active" v-if="data.IsActive == '1'" /> -->
                </span>
              </template>
              <template v-slot:action="{ data }">
                <span>
                  <Button icon="pi pi-eye" class="p-button-rounded p-button-text" @click="viewAssetdetails(data)" />
                </span>
              </template>
            </NormalTableview>
          </div>
        </div>
        <Footer :cancelhide="true" label="Add Agreement" @save="opendetails('first')" @cancel="removeselect()"
          CancelLabel="Remove" type="submit" />
        <!-- <p v-for="items in 20" @click="opendetails('first')">First Content </p>
                <p v-for="items in 20" @click="opendetails('second')">Second Content </p>
                <p v-for="items in 20" @click="opendetails('third')">Third Content</p> -->
      </div>
    </div>
    <div v-if="showdetails" class="secondcontent">
      <div class="sidebar-header">
        <h6 v-if="show == 'second'">Asset Details</h6>
        <h6 v-if="show == 'first'">Add Agreement</h6>

        <i class="pi pi-times" @click="closedetails"> </i>
      </div>

      <div class="sidebar-content">
        <div v-if="show == 'first'">
          <b-row class="px-3">
            <b-col sm="12" md="11" lg="11" xl="10">
              <b-row>
                <b-col lg="4" md="4" sm="6" cols="6" class="form-field-column">
                  <p class="light-txt">
                    {{ t("assetManagement.MassConverstion.itemName") }} :
                  </p>
                </b-col>
                <b-col lg="5" md="6" sm="6" cols="6" class="form-field-column text-start">
                  <p class="fn14 me-3">{{ isDetailForm.ItemName }}</p>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="px-3">
            <b-col sm="12" md="6" lg="6" xl="6">
              <b-row>
                <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
                  <p class="light-txt">
                    {{ t("assetManagement.MassConverstion.serialNumber") }} :
                  </p>
                </b-col>
                <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-start">
                  <p class="fn14">{{ isDetailForm.SerialNumber }}</p>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="px-3">
            <b-col sm="12" md="6" lg="6" xl="6">
              <b-row>
                <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
                  <p class="light-txt">
                    {{ t("assetManagement.MassConverstion.barcode") }} :
                  </p>
                </b-col>
                <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-start">
                  <p class="fn14">{{ isDetailForm.Barcode }}</p>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="12" md="6" lg="6" xl="6">
              <b-row>
                <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
                  <p class="light-txt">
                    {{ t("assetManagement.MassConverstion.rfidTag") }} :
                  </p>
                </b-col>
                <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-start">
                  <p class="fn14">{{ isDetailForm.RFIDTag }}</p>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <!-- {{ isDetailForm }} -->
          <!-- basic -->
          <b-row class="">
            <b-row>
              <b-col>
                <div class="d-flex my-2">
                  <img src="../../../../../../../../assets/Img/icons/downsymbol.svg" alt="" class="down-symbol" />
                  <h6 class="bold-heading mt6 ml-1">
                    {{ t("assetManagement.MassConverstion.basicInformation") }}
                  </h6>
                </div>
              </b-col>
            </b-row>
          </b-row>
          <!-- {{ isDetailForm }}- -->

          <b-row class="px-3">
            <b-col sm="12" md="6" lg="6" xl="6">
              <b-row>
                <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
                  <p class="light-txt">
                    {{ t("assetManagement.MassConverstion.assetType") }} :
                  </p>
                </b-col>
                <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-start">
                  <p class="fn14">{{ isFetchData.ItemCategoryName }}</p>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="12" md="6" lg="6" xl="6">
              <b-row>
                <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
                  <p class="light-txt">
                    {{ t("assetManagement.MassConverstion.location") }} :
                  </p>
                </b-col>
                <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-start">
                  <p class="fn14">{{ isDetailForm.LocationName }}</p>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="px-3">
            <b-col sm="12" md="6" lg="6" xl="6">
              <b-row>
                <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
                  <p class="light-txt">
                    {{ t("assetManagement.MassConverstion.assetGroup") }} :
                  </p>
                </b-col>
                <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-start">
                  <p class="fn14">{{ isDetailForm.ItemName }}</p>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="12" md="6" lg="6" xl="6">
              <b-row>
                <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
                  <p class="light-txt">
                    {{
                      t("assetManagement.MassConverstion.assetLifecycleStage")
                    }}
                    :
                  </p>
                </b-col>
                <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-start">
                  <p class="fn14">{{ isDetailForm.AssetLifecycleStage }}</p>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="px-3">
            <b-col sm="12" md="6" lg="6" xl="6">
              <b-row>
                <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
                  <p class="light-txt">
                    {{ t("assetManagement.MassConverstion.purchaseDate") }} :
                  </p>
                </b-col>
                <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-start">
                  <p class="fn14">{{ isDetailForm.PurchaseDate }}</p>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="12" md="6" lg="6" xl="6">
              <b-row>
                <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
                  <p class="light-txt">
                    {{ t("assetManagement.MassConverstion.purchaseCost") }} :
                  </p>
                </b-col>
                <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-start">
                  <p class="fn14">{{ isDetailForm.PurchaseCost }}</p>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="px-3">
            <b-col sm="12" md="6" lg="6" xl="6">
              <b-row>
                <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
                  <p class="light-txt">
                    {{ t("assetManagement.MassConverstion.supplierName") }} :
                  </p>
                </b-col>
                <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-start">
                  <p class="fn14">{{ isFetchData.SupplierName }}</p>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="12" md="6" lg="6" xl="6">
              <b-row>
                <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column">
                  <p class="light-txt">
                    {{ t("assetManagement.MassConverstion.purchaseOrderNo") }} :
                  </p>
                </b-col>
                <b-col lg="6" md="6" sm="6" cols="6" class="form-field-column text-start">
                  <p class="fn14">{{ isDetailForm.PurchaseOrderNumber }}</p>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-form @submit.prevent="IsSubmitAggrement">
            <AgreementComponents class="my-3" v-model="isDetailForm.AgreementList" :convertiontype="1"
              @update:modelValue="EmitAgreementList" />
            <b-row>
              <b-col lg="8" md="6" sm="12">
                <div class="field">
<<<<<<< HEAD
                  <CustomDropDownfield :label="t('assetManagement.MassConverstion.maintenanceSchedule')
                    " v-model="additionalFields.MaintenanceScheduleID"
                    :items="isDetailForm.MaintenanceScheduleMasterList" :rules="{ required: true }"
                    :required-icon="true" :id="t('assetManagement.MassConverstion.maintenanceSchedule')
                      " :name="t('assetManagement.MassConverstion.maintenanceSchedule')
                        " />
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="8" md="6" sm="12">
                <div class="field">
                  <Textarea v-model="additionalFields.Notes" :requiredIcon="false" placeholder=" " name="Description"
                    id="Description" :label="t('item.description')" :rules="{ required: false }" :rows="1" />
=======
                  <CustomDropDownfield
                    :label="
                      t('assetManagement.MassConverstion.maintenanceSchedule')
                    "
                    v-model="additionalFields.MaintenanceScheduleID"
                    :items="isDetailForm.MaintenanceScheduleMasterList"
                    :rules="{ required: false }"
                    :required-icon="false"
                    :id="
                      t('assetManagement.MassConverstion.maintenanceSchedule')
                    "
                    :name="
                      t('assetManagement.MassConverstion.maintenanceSchedule')
                    "
                  />
>>>>>>> 8ce414db56d7b985243372e430157dc95e9a6516
                </div>
              </b-col>
            </b-row>

            <Footer :cancelhide="true" label="Save" @cancel="closedetails" CancelLabel="Cancel" type="submit" />
          </b-form>
        </div>
        <div v-if="show == 'second'">
          <AssetDetailsComponents :assetDetailsList="assetData" />
        </div>
      </div>
    </div>
  </div>
  <Toast />
  <EditConfirmation :Editmodel="confirmationmodel" HeaderContent="Confirmation" @yes="IsSubmit()"
    @no="confirmationmodel = false" content="Do you want to Create Asset as Empty?" />
</template>
<script lang="ts">
import {
  defineComponent,
  ref,
  onMounted,
  onUnmounted,
  computed,
  watch,
} from "vue";
import { useI18n } from "vue-i18n";
import TextField from "../../../../../../../../components/FormComponents/TextInput.vue";
import CustomDropDownfield from "../../../../../../../../components/FormComponents/Dropdown.vue";
import CustomDatepicker from "../../../../../../../../components/FormComponents/DatePicker.vue";
import NormalTableview from "../../../../../../../../components/FormComponents/NormalTable.vue";
import Footer from "../../../../../../../../components/FormComponents/Footer.vue";
import {
  ScanItemModel,
  AgreementList,
} from "../../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/model/AssetInitialSetup/scanItemModel";
import AgreementComponents from "../../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/components/agreementComponents.vue";
import Textarea from "../../../../../../../../components/FormComponents/TextArea.vue";
import { useRoute, useRouter, onBeforeRouteUpdate } from "vue-router";

import StockInService from "../../../../../../../../modules/Inventory/Service/StockInService";
import ItemMasService from "../../../../../../../../modules/Inventory/Service/ItemMasService";

import AssetMasterService from "../../../../../../../../modules/Inventory/Service/AssetManagement/AssetMasterService";
import MaintenanceScheduleMasterServices from "../../../../../../../../modules/Inventory/Service/AssetManagement/MaintenanceScheduleMasterService";
import AgreementMasterService from "../../../../../../../../modules/Inventory/Service/AssetManagement/AgreementMasterService";

import { useCommonStore } from "../../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/store/CommonStore";

import { useForm } from "vee-validate";
import moment from "moment";
import SkeletonTableLoader from "../../../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import axios, { AxiosResponse } from "axios";
import { AssetItemDetailsModel } from "../../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/model/AssetInitialSetup/assetItemDetailsModel";
import { MaintenanceScheduleMasterData } from "../../../../../../../../modules/Inventory/pages/AssetManagement/Masters/model/maintenanceScheduleMasterModel";
import { useToast } from "primevue/usetoast";
import EditConfirmation from "../../../../../../../../components/FormComponents/EditConfirmation.vue";
import AssetDetailsComponents from "../../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/components/assetDetailsComponents.vue";
import { AgreementItemList } from "../../../model/AssetInitialSetup/assetAgreementModel";

interface FetchData {
  Id: number;
  // Name: string;
  // ItemCategoryName: string;
  ItemGroupName: string;
  StockInHand: number;
  Name: string;
  ItemCategoryName: string;
  SupplierName: string;
  InvoiceNo: string;
  InvoiceDate: string;
  DocNo: string;
  StockInDetailBarcode: string;
  ItemId: number;
  RefMASNo: string;
  BrandName: string;
  ModelNumberName: string;
  SizeName: string;
}
interface AdditionalFields {
  IsNew: boolean;
  IsModified: boolean;
  IsDeleted: boolean;
  IsActive: boolean;
  CreatedAt: string;
  ModifiedAt: string;
  CreatedBy: number;
  ModifiedBy: number;
  CreatedByName: string;
  ModifiedByName: string;
  EntityId: number;
  EntityOperationId: number;
  DeptRoleId: number;
  HospitalId: number;
  BranchId: number;
  FromStoreBranchId: number;
  ToStoreBranchId: number;
  IsEntitySMS: number;
  OrganizationName: string;
  BranchName: string;
  FromStoreBranchName: string;
  ToStoreBranchName: string;
  TaskStatus: number;
  TaskExpiryDate: string;
  TaskName: string;
  TaskPriority: number;
  ResponseTimeInHours: number;
  IsApprovalRequired: boolean;
  LevelsOfApproval: number;
  Id: number;
  AssetID: number;
  AgreementType: number;
  Provider: number;
  AgreementStartDate: string;
  AgreementEndDate: string;
  AgreementStatus: string;
  BuyoutOption: string;
  CoverageType: string;
  PolicyNumber: string;
  Amount: number;
  Premium: string;
  RenewalTerms: string;
  CoverageDetails: string;
  PaymentSchedule: number;
  Notes: any;
  UpdatedAt: string;
  UpdatedBy: string;
  WarrantyStatus: string;
  OutstandingPayments: number;
  ExpiryReason: string;
  PreviousAgreementID: number;
  MonthlyPayment: any;
  TotalLeaseCost: any;
  LessorName: string;
  TerminationDate: string;
  TerminationReason: string;
  AgreementName: string;
  DepreciationMethodID: number;
  DepreciationRate: number;
  MaintenanceScheduleID: number;
  AssetIdVar: string;
  AgreementIdVar: string;
}

export default defineComponent({
  props: {
    trigger: {
      type: Boolean,
      default: true,
    },
    selectedItem: {
      type: Object,
      Default: () => { },
    },
  },
  emits: ['loaderhide', 'triggerclose', 'update:selectedItem'],
  components: {
    Textarea,
    Footer,
    TextField,
    CustomDropDownfield,
    CustomDatepicker,
    NormalTableview,
    AgreementComponents,
    SkeletonTableLoader,
    AssetDetailsComponents,
    EditConfirmation,
  },
  setup(props, { emit }) {
    const showdetailrightsidebar = ref(false);
    const commonStore = useCommonStore();
    const toast = useToast();
    const confirmationmodel = ref(false);

    const showdetails = ref(false);
    const loading = ref(false);
    const show = ref();
    const { t } = useI18n();
    const model: any = ref(props.selectedItem);
    const { handleSubmit, errors, resetForm, resetField } = useForm();

    const sidebarwidth = computed(() => {
      return showdetails.value ? "70rem" : "30rem";
    });
    let scannedItems: any = ref([{}]);
    let assetDetailsItems: any = ref([{}]);
    let selectedProduct: any = ref([]);

    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    let HospitalId = Number(usersData.OrganizationId);

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }
    const route = useRoute();

    const data = route.query.data as string;
    const queryform = JSON.parse(data);

    function closedetailsrightsidebar() {
      showdetailrightsidebar.value = false;
      // showdetails.value = false;
      resetForm();
      agreementType.value = [];

      emit("update:selectedItem", undefined);
      emit("triggerclose");
    }
    let StockInDetailId = ref(0);
    async function itemDataFetch(data) {
      debugger;
      try {
        try {
          loading.value = true;
          const data_response = await StockInService.getlistByStockInId(
            // queryform.StockTransId
            data.StockInDetailId
          );

          const data1 = data_response["result"];
          console.log(data_response["result"]);
          Object.keys(isFetchData.value).forEach((key) => {
            if (data1[0][key]) isFetchData.value[key] = data1[0][key];
          });
          isForm.value.StockInDetailId = data1[0].StockInDetailId;
          // alert(JSON.stringify(data1[0]))
          const response = await ItemMasService.Edit(data.ItemId, HospitalId);
          const data2 = response["result"];

          Object.keys(isFetchData.value).forEach((key) => {
            if (data2[key]) isFetchData.value[key] = data2[key];
          });

          isForm.value.ItemId = response["result"].Id;
          isForm.value.CategoryId = response["result"].ItemTypeId;
          isForm.value.SubCategoryId = response["result"].SubGroupId;
          isForm.value.AssetGroupId = response["result"].ItemGroupId;
          StockInDetailId.value = data1[0].StockInDetailId;
          loading.value = false;
        } catch (error) {
          loading.value = false;
          alert(error);
        }
      } catch (error) {
        console.error(error);
      }
    }

    const headers = [
      {
        header: t("assetManagement.MassConverstion.code"),
        field: "Code",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },

      {
        header: t("assetManagement.MassConverstion.barcode"),
        field: "Barcode",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.MassConverstion.serialNumber"),
        field: "SerialNumber",
        class: "mediumwidth",
      },
      {
        header: t("assetManagement.MassConverstion.agreementType"),
        field: "AgreementName",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
        slot: "AgreementName",
        fieldDisplay: "false",
      },

      {
        header: t("assetManagement.MassConverstion.modelno"),
        field: "ModelNo",
        class: "mediumwidth",
      },

      {
        header: "",
        field: "action",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];
    const assetDetailsheaders = [
      {
        header: t("assetManagement.MassConverstion.code"),
        field: "Code",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("assetManagement.MassConverstion.itemName"),
        field: "Code",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },

      {
        header: t("assetManagement.MassConverstion.serialNumber"),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t("assetManagement.MassConverstion.assetLifecycleStage"),
        field: "Name",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("assetManagement.MassConverstion.department"),
        field: "Name",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("assetManagement.MassConverstion.status"),
        field: "ActiveStatus",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        slot: "Status",
      },
      {
        header: "",
        field: "action",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];

    async function opendetails(value) {
      if (selectedProduct.value.length != 0) {
        showdetails.value = true;
        await LoadItemDetailsByAssetId();
        show.value = value;
      } else {
        toast.add({
          severity: "warn",
          summary: "Select the Agreement Type",
          detail: "",
          life: 3000,
        });
      }
    }
    function removeselect() {
      selectedProduct.value = [];
    }
    function closedetails() {
      show.value = "";

      showdetails.value = false;
      // emit("update:selectedItem", undefined);
    }
    let agreementType: any = ref([]);
    const isvarForm = ref({
      qtyLoop: ref(),
    });
    // const qtyLoop = ref()
    const isForm = ref<ScanItemModel>({
      IsNew: false,
      IsModified: false,
      IsDeleted: false,
      IsActive: false,
      CreatedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      ModifiedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      CreatedBy: 0,
      ModifiedBy: 0,
      ItemName: "",
      CreatedByName: "",
      ModifiedByName: "",
      EntityId: 0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      HospitalId: 0,
      BranchId: 0,
      TrackingMechanism: 0,
      FromStoreBranchId: 0,
      ToStoreBranchId: 0,
      IsEntitySMS: 0,
      OrganizationName: "",
      StockInId: queryform.StockTransId,
      GrnpoNumber: queryform.GrnpoNumber,
      GrnpoId: queryform.GrnpoId,
      BranchName: "",
      FromStoreBranchName: "",
      ToStoreBranchName: "",
      TaskStatus: 0,
      TaskExpiryDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      TaskName: "",
      TaskPriority: 0,
      ResponseTimeInHours: 0,
      IsApprovalRequired: false,
      LevelsOfApproval: 0,
      ModelNo: "",
      Id: 0,
      AssetDisplayId: "",
      StoreID: queryform.StoreId,

      ItemId: 0,
      CategoryId: 0,
      SubCategoryId: 0,
      AssetGroupId: 0,
      SerialNumber: "",
      AssetType: "2",
      PurchaseDate: "",
      PurchaseCost: 0,
      SupplierName: 0,
      PurchaseOrderNumber: "",
      CurrentValue: 0,
      DepreciationMethodID: 1,
      DepreciationRate: 0,
      //required
      DepreciationStartDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      MaintenanceScheduleID: 0,
      LocationID: 0,
      StatusID: 1,
      BarCode: "",

      RfidTag: "",
      AssetLifecycleStage: 0,
      UpdatedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      UpdatedBy: "",
      FairMarketValue: 0.0,
      //required
      LastFMVAssessmentDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      IssueStatus: 0,
      RequestedBy: "",
      RequestId: 0,
      ToStoreId: queryform.StoreId,
      FromStoreId: queryform.StoreId,
      Type: 1,
      StockInDetailId: 0,
      Qty: 1,
      DocType: 0,
      IsApproved: 1,
      AgreementList: <AgreementList[]>[],
    });
    const isDetailForm = ref({
      AssetId: "",
      SerialNumber: "",
      LocationName: "",
      Barcode: "",
      ItemName: "",
      RFIDTag: "",
      AssetType: "2",
      LocationID: 1,
      AssetLifecycleStage: 0,
      PurchaseDate: "",
      PurchaseCost: "",
      SupplierName: 0,
      PurchaseOrderNumber: "",

      AgreementList: <AgreementList[]>[],
      MaintenanceScheduleMasterList: [],
    });

    const updateAgreementList = () => {
      isForm.value.AgreementList = agreementType.value.map((type) => ({
        IsNew: true,
        IsModified: true,
        IsDeleted: false,
        IsActive: true,
        CreatedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        ModifiedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        CreatedBy: 0,
        ModifiedBy: 0,
        CreatedByName: "",
        ModifiedByName: "",
        EntityId: 0,
        EntityOperationId: 0,
        DeptRoleId: 0,
        HospitalId: 0,
        BranchId: 0,
        FromStoreBranchId: 0,
        ToStoreBranchId: 0,
        IsEntitySMS: 0,
        OrganizationName: "",
        BranchName: "",
        FromStoreBranchName: "",
        ToStoreBranchName: "",
        TaskStatus: 0,
        TaskExpiryDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        TaskName: "",
        TaskPriority: 0,
        ResponseTimeInHours: 0,
        IsApprovalRequired: true,
        LevelsOfApproval: 0,
        Id: 0,
        AssetID: 0,
        AgreementType: type,
        Provider: ref(),
        AgreementStartDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        AgreementEndDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        AgreementStatus: "0",
        BuyoutOption: "",
        CoverageType: "",
        PolicyNumber: "",
        Amount: 0,
        Premium: "",
        RenewalTerms: "",
        CoverageDetails: "",
        PaymentSchedule: 0,
        Notes: "",
        UpdatedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        UpdatedBy: "",
        WarrantyStatus: "",
        OutstandingPayments: 0,
        ExpiryReason: "",
        PreviousAgreementID: 0,
        MonthlyPayment: 0.0,
        TotalLeaseCost: 0.0,
        LessorName: "",
        TerminationDate: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
        TerminationReason: "",
        Code: "",
        Barcode: "",
        BarcodeNumber: 0,
      }));
      //   alert(JSON.stringify(isForm.value.AgreementList))
      //   alert(JSON.stringify(isForm.value.AgreementList.length))
    };

    const isFetchData = ref<FetchData>({
      Id: 0,
      Name: "",
      ItemCategoryName: "",
      ItemGroupName: "",
      SupplierName: "",
      InvoiceDate: "",
      InvoiceNo: "",
      DocNo: "",
      StockInHand: 0,
      StockInDetailBarcode: "",
      ItemId: 0,
      RefMASNo: "",
      BrandName: "",
      ModelNumberName: "",
      SizeName: "",
    });

    let assetDetails = ref(false);
    let assetData = ref();

    const viewAssetdetails = (event) => {
      // opendetails("second"),
      showdetails.value = true;
      show.value = "second";
      // alert(JSON.stringify(event))
      assetData.value = event;
      // assetDetails.value = true;
    };
    //  onMounted(() => {
    //     debugger;
    //     //  commonStore.Loadlocation();
    // });

    const IsSubmit = handleSubmit(async (values) => {
      debugger;
      emit("loadershow");

      try {
        let msg = "";

        isForm.value.BranchId = queryform.BranchId;
        isForm.value.HospitalId = usersData.OrganizationId;
        isForm.value.ModifiedBy = usersData.UserId;
        isForm.value.CreatedBy = usersData.UserId;
        isForm.value.ItemId = isFetchData.value.Id;
        isForm.value.Type = 1;
        isForm.value.EntityId = 3117;
        isForm.value.DocType = queryform.DocType;
        isForm.value.StockInDetailId = StockInDetailId.value;
        isForm.value.PurchaseOrderNumber = isFetchData.value.RefMASNo;

        // Number(usersData.EntityId);

        if (isForm.value.Id != 0) {
          const data_response = await AssetMasterService.updatedata(
            isForm.value
          );
          console.log(data_response);
          msg = data_response["ErrorInfo"].ErrorCode;
          emit("loaderhide");
        } else {
          isForm.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
          isForm.value.PurchaseDate = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          let data_response: any;
          if (isvarForm.value.qtyLoop) {
            for (let i = 0; i < isvarForm.value.qtyLoop; i++) {
              // const element = array[i];
              data_response = await AssetMasterService.createdata(isForm.value);
              // resetForm();
              // agreementType.value = [];
            }
          } else {
            data_response = await AssetMasterService.createdata(isForm.value);
          }
          console.log(data_response);
          msg = data_response["ErrorInfo"].ErrorCode;
          emit("loaderhide");
          if (data_response["result"] == null) {
            toast.add({
              severity: "warn",
              summary: "Serial Number Already Exist",
              detail: "",
              life: 3000,
            });

            // agreementType.value = [];
            // commonStore.LoadlistAssetByItemId(isFetchData.value.Id, queryform.StockTransId);
          } else if (data_response["result"].length != 0) {
            confirmationmodel.value = false;
            toast.add({
              severity: "success",
              summary: "Added",
              detail: "",
              life: 3000,
            });

            resetForm();
            agreementType.value = [];
            commonStore.LoadlistAssetByItemId(
              isFetchData.value.ItemId,
              queryform.StockTransId,
              HospitalId,
              queryform.BranchId,
              queryform.StoreId,
              isForm.value.StockInDetailId
            );
          }
        }
      } catch (error) {
        emit("loaderhide");
        alert(error);
      }
    });

    const additionalFields: AdditionalFields = {
      IsNew: true,
      IsModified: true,
      IsDeleted: true,
      IsActive: true,
      CreatedAt: "2024-10-21T11:08:12.677Z",
      ModifiedAt: "2024-10-21T11:08:12.677Z",
      CreatedBy: 0,
      ModifiedBy: 0,
      CreatedByName: "",
      ModifiedByName: "",
      EntityId: 0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      HospitalId: 0,
      BranchId: 0,
      FromStoreBranchId: 0,
      ToStoreBranchId: 0,
      IsEntitySMS: 0,
      OrganizationName: "",
      BranchName: "",
      FromStoreBranchName: "",
      ToStoreBranchName: "",
      TaskStatus: 0,
      TaskExpiryDate: "2024-10-21T11:08:12.677Z",
      TaskName: "",
      TaskPriority: 0,
      ResponseTimeInHours: 0,
      IsApprovalRequired: true,
      LevelsOfApproval: 0,
      Id: 0,
      AssetID: 0,
      AgreementType: 0,
      Provider: 0,
      AgreementStartDate: "2024-10-21T11:08:12.678Z",
      AgreementEndDate: "2024-10-21T11:08:12.678Z",
      AgreementStatus: "0",
      BuyoutOption: "",
      CoverageType: "",
      PolicyNumber: "",
      Amount: 0,
      Premium: "",
      RenewalTerms: "",
      CoverageDetails: "",
      PaymentSchedule: 0,
      Notes: "",
      UpdatedAt: "2024-10-21T11:08:12.678Z",
      UpdatedBy: "",
      WarrantyStatus: "",
      OutstandingPayments: 0,
      ExpiryReason: "",
      PreviousAgreementID: 0,
      MonthlyPayment: 0.0,
      TotalLeaseCost: 0.0,
      LessorName: "",
      TerminationDate: "2024-10-21T11:08:12.678Z",
      TerminationReason: "",
      AgreementName: "",
      DepreciationMethodID: 0,
      DepreciationRate: 0.0,
      MaintenanceScheduleID: 0,
      AssetIdVar: "",
      AgreementIdVar: "",
    };
    // Merging additional fields into the original array, setting AssetId to 0, and avoiding duplicate vars

    const IsSubmitAggrement = handleSubmit(async (values) => {

      debugger;
      // emit("loadershow");

      try {
        let msg = "";

        isForm.value.BranchId = queryform.BranchId;
        isForm.value.HospitalId = usersData.OrganizationId;
        isForm.value.ModifiedBy = usersData.UserId;
        isForm.value.CreatedBy = usersData.UserId;
        isForm.value.ItemId = isFetchData.value.Id;
        // isForm.value. = usersData.UserId;

        isForm.value.EntityId = 1;
        // Number(usersData.EntityId);

        isForm.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        // isForm.value.PurchaseDate = moment().format(
        //     "YYYY-MM-DDTHH:mm:ss.SSSZ"
        // );

        function removeDuplicates(original: any, additional: any) {
          const filteredAdditional = Object.keys(additional)
            .filter((key) => !(key in original)) // Only include keys not present in the original object
            .reduce((obj, key) => {
              obj[key] = additional[key];
              return obj;
            }, {} as any);

          return filteredAdditional;
        }
        let updatedArray: any = ref([]);
        // Merging additional fields without duplicates into the original array and setting AssetId to 0

        updatedArray.value = isDetailForm.value.AgreementList.map((item) => ({
          ...removeDuplicates(item, additionalFields),
          // Filter additional fields to remove duplicates
          ...item, // Retain original values
          // isForm.value.PurchaseDate = moment().format(
          //     "YYYY-MM-DDTHH:mm:ss.SSSZ"s
          // );
          AgreementStartDate: moment(item.AgreementStartDate, 'DD-MM-YYYY').format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
          AgreementStatus: "1",
          Amount: Number(item.Amount),
          BuyoutOption: item.BuyoutOption == true ? "true" : "false",
          AgreementEndDate: moment(item.AgreementEndDate, 'DD-MM-YYYY').format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
          UpdatedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
          Notes: additionalFields.Notes,
          MaintenanceScheduleID: additionalFields.MaintenanceScheduleID

        }));

        console.log(updatedArray.value);

        const data_response = await AgreementMasterService.updatedata(
          updatedArray.value
        );
        console.log(data_response);
        msg = data_response["ErrorInfo"].ErrorCode;
        emit("loaderhide");
        if (data_response["result"] == false) {
          // resetForm();
          toast.add({
            severity: "success",
            summary: "Agreement Added",
            detail: "",
            life: 3000,
          });
          closedetails()

        }
      } catch (error) {
        emit("loaderhide");
        console.log(error);
      }
    });

    const errorMessage = ref("");
    const isNewlyLeased = ref(true); // Set this based on your asset data

    const checkboxOptions = computed(() => [
      { value: 4, label: t("assetManagement.MassConverstion.lease") },
      { value: 2, label: t("assetManagement.MassConverstion.insurance") },
      { value: 1, label: t("assetManagement.MassConverstion.amc") },
      { value: 3, label: t("assetManagement.MassConverstion.warranty") },
    ]);

    // const isDisabled = (value) => {
    //     if (agreementType.value.length >= 2 && !agreementType.value.includes(value)) return true;
    //     if (value === 3 && agreementType.value.includes(4)) return true; // Disable AMC if Warranty is selected
    //     if (value === 4 && agreementType.value.includes(3)) return true; // Disable Warranty if AMC is selected
    //     if (value === 3 && agreementType.value.includes(1)) return true; // Disable AMC if Lease is selected
    //     if (value === 1 && agreementType.value.includes(3)) return true; // Disable Lease if AMC is selected
    //     return false;
    // };
    const isDisabled = (value) => {
      // If already 2 selections and current value not included, disable
      if (
        agreementType.value.length >= 2 &&
        !agreementType.value.includes(value)
      )
        return true;

      // AMC (1) and Warranty (3) cannot be selected together
      if (value === 1 && agreementType.value.includes(3)) return true; // Disable AMC if Warranty is selected
      if (value === 3 && agreementType.value.includes(1)) return true; // Disable Warranty if AMC is selected

      // AMC (1) and Lease (4) cannot be selected together
      if (value === 1 && agreementType.value.includes(4)) return true; // Disable AMC if Lease is selected
      if (value === 4 && agreementType.value.includes(1)) return true; // Disable Lease if AMC is selected

      return false;
    };

    const handleChange = (changedValue) => {
      errorMessage.value = "";

      // Limit to two selections
      if (agreementType.value.length > 2) {
        agreementType.value = agreementType.value.filter(
          (v) =>
            v === changedValue ||
            v === agreementType.value[agreementType.value.length - 2]
        );
      }

      // Warranty and AMC rule
      if (agreementType.value.includes(3) && agreementType.value.includes(4)) {
        if (changedValue === 3) {
          agreementType.value = agreementType.value.filter((v) => v !== 4);
        } else {
          agreementType.value = agreementType.value.filter((v) => v !== 3);
        }
        errorMessage.value =
          "Warranty is active. AMC can only be applied after the warranty expires.";
      }

      // Warranty and Lease rule
      if (
        agreementType.value.includes(1) &&
        agreementType.value.includes(4) &&
        !isNewlyLeased.value
      ) {
        errorMessage.value =
          "Leased asset cannot have a warranty if it is not newly purchased.";
      }

      // Combination rule
      if (agreementType.value.includes(3) && agreementType.value.includes(4)) {
        errorMessage.value =
          "AMC cannot be applied while the asset is under Warranty.";
      }

      updateAgreementList();
    };
    watch(
      () => props.selectedItem,
      async (newVal) => {
        debugger;

        try {
          loading.value = true;
          // await commonStore.Loadlocation();
          if (props.selectedItem) {
            loading.value = true;
            await itemDataFetch(props.selectedItem);
          }
        } catch (error) {
          console.error("Error in onMounted:", error);
        } finally {
        }
      }
    );

    watch(
      () => isFetchData.value.Id,
      async (newVal, oldVal) => {
        debugger;
        // alert(JSON.stringify(isFetchData.value))
        try {
          loading.value = true;
          // await commonStore.Loadlocation();
          console.log("Store actions:", Object.keys(commonStore));
          if (isFetchData.value.Id && newVal !== oldVal && newVal) {
            await commonStore.LoadlistAssetByItemId(
              isFetchData.value.ItemId,
              queryform.StockTransId,
              HospitalId,
              queryform.BranchId,
              queryform.StoreId,
              isForm.value.StockInDetailId
            );
          }
        } catch (error) {
          console.error("Error in onMounted:", error);
          loading.value = false;
        } finally {
          loading.value = false;
        }
      }
    );
    const combinedId = computed(() =>
      selectedProduct.value.map((asset) => asset.AssetId).join(",")
    );
    async function LoadItemDetailsByAssetId() {
      debugger;
      try {
        // alert(combinedId.value)
        const response: AxiosResponse<AssetItemDetailsModel> =
          await AssetMasterService.getItemDetailsByAssetId(combinedId.value);
        // alert(JSON.stringify(response["result"]['agreement']))
        if (response["result"]["agreement"].length != 0) {
          isDetailForm.value.AgreementList =
            response["result"]["agreement"].length != 0
              ? response["result"]["agreement"]
              : [];
        }

        let data = response["result"]["asset"][0];
        Object.keys(isDetailForm.value).forEach((key) => {
          if (data[key]) isDetailForm.value[key] = data[key];
        });
        let data1 = response["result"]["agreement"][0];

        Object.keys(additionalFields).forEach((key) => {
          if (data1[key]) additionalFields[key] = data1[key];
        });
        isFetchData.value.StockInHand = model.Quantity;
        console.log(response["result"]);
      } catch (error) {
        alert(error);
      }
    }
    // const isDisabledtxt = (value) => {
    //     alert(Number(isFetchData.value.StockInHand) == Number(value))
    //     if (value <= Number(isFetchData.value.StockInHand))
    //         return true;
    //     return false;
    // };
    async function LoadIMaintenanceScheduleMaster() {
      debugger;
      try {
        const response: AxiosResponse<MaintenanceScheduleMasterData> =
          await MaintenanceScheduleMasterServices.getdata();

        isDetailForm.value.MaintenanceScheduleMasterList = response[
          "result"
        ].map((item) => {
          item.name = item.MaintenanceType;
          item.value = item.Id;
          return item;
        });
      } catch (error) {
        alert(error);
      }
    }
    function isSubmitvalidate() {
      if (isForm.value.SerialNumber == "") {
        if (Number(isvarForm.value.qtyLoop) == 0) {
          toast.add({
            severity: "warn",
            summary: "Please check the quantity value",
            detail: "",
            life: 3000,
          });
          isvarForm.value.qtyLoop = "";
        } else {
          confirmationmodel.value = true;
        }
      } else {
        IsSubmit();
      }
    }

    function handleQtyChange() {
      // alert(Number(props.selectedItem!.Quantity))
      // && commonStore.option.listAssetByItem.length >= Number(props.selectedItem!.Quantity)
      let cal =
        Number(props.selectedItem!.Quantity) -
        commonStore.option.listAssetByItem.length;
      if (Number(cal) < Number(isvarForm.value.qtyLoop)) {
        toast.add({
          severity: "warn",
          summary: "Please check the quantity value",
          detail: "",
          life: 3000,
        });
        isvarForm.value.qtyLoop = "";
      }
    }

    function handleSerialNoChange() {
      // alert(isvarForm.value.qtyLoop)
      if (isvarForm.value.qtyLoop!) {
        toast.add({
          severity: "warn",
          summary:
            "Serial number input is restricted. Please check the quantity value",
          detail: "",
          life: 3000,
        });
        isForm.value.SerialNumber = "";
        isvarForm.value.qtyLoop = "";
        // confirmationmodel.value = true
      }
    }
    const getTrackingLabel = () => {
      switch (isForm.value.TrackingMechanism) {
        case 1:
          return "RFID Tag";
        case 2:
          return "GPS ID";
        case 3:
          return "Bluetooth ID";
        default:
          return "Tag ID";
      }
    };
    const getAgreementNames = (data: any): string[] => {
      return data.AgreementName
        ? data.AgreementName.split(",").map((name) => name.trim())
        : [];
    };

    const isAgreementActive = (name: string, status: string): boolean => {
      const statuses = status ? status.split(",").map((s) => s.trim()) : [];
      return statuses.includes(name);
    };

    const EmitAgreementList = (data) => {

    };

    onMounted(async () => {
      try {
        await commonStore.Loadlocation();
        await LoadIMaintenanceScheduleMaster();
      } catch (error) {
        console.error("Error in onMounted:", error);
      } finally {
      }
    });
    return {
      getAgreementNames,
      isAgreementActive,
      getTrackingLabel,
      handleQtyChange,
      handleSerialNoChange,
      isSubmitvalidate,
      assetData,
      // isDisabledtxt,
      isvarForm,
      confirmationmodel,
      additionalFields,
      combinedId,
      isDetailForm,
      commonStore,
      agreementType,
      errorMessage,
      checkboxOptions,
      isDisabled,
      handleChange,
      IsSubmit,
      isFetchData,
      model,
      assetDetails,
      viewAssetdetails,
      IsSubmitAggrement,
      loading,
      isForm,
      t,
      sidebarwidth,
      showdetailrightsidebar,
      // opendetailrightsidebar,
      closedetailsrightsidebar,
      opendetails,
      closedetails,
      showdetails,
      show,
      scannedItems,
      selectedProduct,
      headers,
      assetDetailsheaders,
      assetDetailsItems,
      removeselect,
      HospitalId,
      EmitAgreementList,
    };
  },
});
</script>

<style lang="scss" scoped>
.rightdetailssidebar {
  display: flex;
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  transition: all 0.3s ease;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  z-index: 100;

  .sidebar-header {
    position: relative;
    display: flex;
    gap: 10px;
    justify-content: space-between;
    padding: 15px;
    border-bottom: 1px solid #e1e1e1;
    border-right: 1px solid #e1e1e1;

    .pi-arrow-right {
      position: absolute;
      left: -15px;
      top: 60px;
      background: #e1e1e1;
      font-size: 14px;
      height: 30px;
      width: 30px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .firstcontent {
    width: 30rem;
    flex-shrink: 0;
  }

  .secondcontent {
    width: 40rem;
    //flex-shrink: 0;
  }

  .sidebar-content {
    padding: 0px 15px 15px;
    max-height: calc(100vh - 44.8px);
    overflow: auto;
    transition: width 0.3s ease;
    flex-grow: 1;
  }
}

.form-field-column {
  margin: 8px 0px;
}

.display-field-label {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
}

.details-black-field {
  color: #444444;
  font-size: 14px;
}

.small-light-txt {
  font-size: 12px;
  color: #999999;
}

.disableclass {
  pointer-events: none;
  opacity: 0.5;
}
</style>
